import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const AffiliateDashboard = React.lazy(
  () =>
    import(/* webpackChunkName: "admin-affiliates-dashboard" */ "../dashboard"),
);
const AffiliateList = React.lazy(
  () =>
    import(/* webpackChunkName: "admin-affiliates-list" */ "./affiliate-list"),
);
const AffiliatePayouts = React.lazy(
  () =>
    import(
      /* webpackChunkName: "admin-affiliates-payouts" */ "./payout-requests"
    ),
);
const CommissionSettings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "admin-affiliates-settings" */ "../../app/affiliates/commission-settings"
    ),
);
const AffiliateReports = React.lazy(
  () =>
    import(
      /* webpackChunkName: "admin-affiliates-reports" */ "../../app/affiliates/reports"
    ),
);
const FraudControl = React.lazy(
  () =>
    import(
      /* webpackChunkName: "affiliates-fraud" */ "../../app/affiliates/fraud-control"
    ),
);
const MarketingKitAdmin = React.lazy(
  () =>
    import(
      /* webpackChunkName: "affiliates-marketing-kit" */ "../../app/affiliates/marketing-kit"
    ),
);
const AffiliateCampaigns = React.lazy(
  () =>
    import(/* webpackChunkName: "admin-affiliates-campaigns" */ "./campaigns"),
);

const AdminAffiliatesRouter = ({ match }) => (
  <Suspense fallback={<div className="loading" />}>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboard`} />
      <Route
        path={`${match.url}/dashboard`}
        render={(props) => <AffiliateDashboard {...props} />}
      />
      <Route
        path={`${match.url}/list`}
        render={(props) => <AffiliateList {...props} />}
      />
      <Route
        path={`${match.url}/payouts`}
        render={(props) => <AffiliatePayouts {...props} />}
      />
      <Route
        path={`${match.url}/commission`}
        render={(props) => <CommissionSettings {...props} />}
      />
      <Route
        path={`${match.url}/marketing-kit`}
        render={(props) => <MarketingKitAdmin {...props} />}
      />
      <Route
        path={`${match.url}/campaigns`}
        render={(props) => <AffiliateCampaigns {...props} />}
      />
      <Route
        path={`${match.url}/reports`}
        render={(props) => <AffiliateReports {...props} />}
      />
      <Route
        path={`${match.url}/fraud`}
        render={(props) => <FraudControl {...props} />}
      />
      <Redirect to="/error" />
    </Switch>
  </Suspense>
);

export default AdminAffiliatesRouter;
